import { useTranslation } from "react-i18next";

import { FeaturedIcon } from "@unified-checkout/design-system";
import { Clock, File } from '@unified-checkout/design-system/icons/index';
import { formatToLocalizedDateTime } from "libs/design-system/src/utils/dateFormats";
import type { TFeaturedIconColor } from "libs/design-system/src/types/featured_icon/featuredIcon";

import { useLangStore } from "@app/dashboard/store/lang";
import { LabeledBox } from "../../components/LabeledBox";
import styles from "./case-history.module.scss";


type TItem = {
  label?: string,
  hint?: string,
  color?: TFeaturedIconColor,
  waiting?: boolean
};


const Item = ({ label, hint, color, waiting }: TItem) => {

  return (
    <div
      className={styles["case-history__item"]}
      data-case-history-item-waiting={!!waiting}
    >
      <FeaturedIcon
        size="sm"
        color={color || 'primary'}
        variant='contained'
        icon={waiting ? Clock : File}
      />
      {
        (label || hint) &&
        <div className={styles["case-history__text-box"]}>
          {label && <div className={styles["case-history__text-box__label"]}>{label}</div>}
          {hint && <div className={styles["case-history__text-box__hint"]}>{hint}</div>}
        </div>
      }
    </div>
  )
};


export const CaseHistory = ({ events }: { events?: Record<string, any>[] }) => {
  const { t } = useTranslation();
  const { lang } = useLangStore();

  const ITEM_LISTING: TItem[] = (events || []).map(ev => ({
    label: ev.new_status_label,
    color: "gray",
    hint: formatToLocalizedDateTime(ev.created_at, lang)
  }))


  return (
    <LabeledBox
      label={t('innerLayout.disputesPage.disputeDetails.detailsBoxes.caseHistory.title')}
    >
      <div className={styles["case-history-listing"]}>
        {
          ITEM_LISTING.map((item, index) => <Item key={index} {...item} />)
        }
      </div>
    </LabeledBox>

  )
}